import React, { useCallback } from 'react'
import { CircleCloseIcon } from '@/atoms/Icons/CircleCloseIcon'
import { slugs } from '@/constants/slugs'
import { ExperimentVariation, GBFadeInExperiment } from '@/experimentation'
import { EmbeddedVideo } from '@/molecules/EmbeddedVideo'
import { Modal } from '@/molecules/Modal/Modal'

export interface GiveawayVideoModalProps {
  youTubeUrl?: string | null
  handleClose: () => void
  showModal: boolean
  theatricalSlug: string
}

export const GiveawayVideoModal: React.FC<GiveawayVideoModalProps> = ({
  youTubeUrl,
  handleClose,
  showModal,
  theatricalSlug,
}) => {
  const handleModalClose = useCallback(() => {
    handleClose()
  }, [handleClose])

  return (
    <Modal
      isOpen={showModal}
      onClose={handleModalClose}
      panelClasses="min-w-[80vw] !overflow-visible lg:min-w-[55vw] !bg-transparent !p-0 !shadow-none"
    >
      <div className="relative rounded-xl">
        {theatricalSlug !== slugs.kingOfKings && <EmbeddedVideo url={`${youTubeUrl}?autoplay=1`} className="w-full" />}

        {theatricalSlug === slugs.kingOfKings && (
          <GBFadeInExperiment experimentName="king-of-kings-video" defaultValue={false}>
            <ExperimentVariation variation={true}>
              <EmbeddedVideo url={'https://www.youtube-nocookie.com/embed/tOudE4H1kvM?autoplay=1'} className="w-full" />
            </ExperimentVariation>
            <ExperimentVariation default>
              <EmbeddedVideo url={`${youTubeUrl}`} className="w-full" />
            </ExperimentVariation>
          </GBFadeInExperiment>
        )}
        <div
          className="absolute -top-10 right-1 z-[10000000] h-8 w-8 cursor-pointer rounded-full bg-transparent transition-all duration-300 ease-in-out hover:opacity-80 md:-right-4"
          onClick={handleModalClose}
        >
          <CircleCloseIcon color="core-gray-100" size={32} className="cursor-pointer" />
        </div>
      </div>
    </Modal>
  )
}
